import { AxiosInstance } from 'axios'

/**
 * Creates poll item
 * @param {AxiosInstance} axios
 * @param {string} objectType
 * @param {string} objectId
 * @param {string} name
 * @param {boolean} active
 */
export const createPoll = (axios, objectType, objectId, name, active) => {
  const data = {
    object_type: objectType,
    object_id: objectId,
    name: name,
    active: active,
  }
  return axios.post(`/v1/polls/poll`, data)
}

/**
 * Updates poll item
 * @param {AxiosInstance} axios
 * @param {string} pollId
 * @param {object} data
 * @return {Promise}
 */
export const updatePoll = (axios, pollId, data) => {
  return axios.post(`/v1/polls/poll/${pollId}`, data)
}

/**
 * Gets poll item
 * @param {AxiosInstance} axios
 * @param {string} objectType
 * @param {string} objectId
 * @return {Promise}
 */
export const getPoll = (axios, objectType, objectId) => {
  return axios.get(`/v1/polls/poll/${objectType}/${objectId}`)
}

/**
 * Deletes poll item
 * @param {AxiosInstance} axios
 * @param {string} pollId
 * @return {Promise}
 */
export const deletePoll = (axios, pollId) => {
  return axios.delete(`/v1/polls/poll/${pollId}`)
}

/**
 * @param {AxiosInstance} axios
 * @param {string} questionId
 * @return {Promise}
 */
export const getPollQuestion = (axios, questionId) => {
  return axios.get(`/v1/polls/question/${questionId}`)
}

export const createPollQuestion = (axios, pollId, text, sort) => {
  return axios.post(`/v1/polls/question`, { poll_id: pollId, text: text, sort: Number(sort) })
}

export const updatePollQuestion = (axios, questionId, pollId, text, sort) => {
  return axios.post(`/v1/polls/question/${questionId}`, {
    poll_id: pollId,
    text: text,
    sort: Number(sort),
  })
}

export const deletePollQuestion = (axios, questionId) => {
  return axios.delete(`/v1/polls/question/${questionId}`)
}

export const addQuestionOption = (axios, questionId, data) => {
  data.question_id = questionId
  return axios.post(`/v1/polls/question-option`, data)
}

export const updateQuestionOption = (axios, optionId, questionId, data) => {
  data.question_id = questionId
  return axios.post(`/v1/polls/question-option/${optionId}`, data)
}

export const deleteQuestionOption = (axios, optionId) => {
  return axios.delete(`/v1/polls/question-option/${optionId}`)
}

export const POLL_OBJECTS = {
  HPS_COURSE: 'hps_courses',
  HPS_LECTURE: 'hps_lectures',
}

export const DEFAULT_QUESTION = {
  id: '',
  text: '',
  sort: 0,
  options: [],
}

export const DEFAULT_POLL = { id: '', name: '', active: false, questions: null }

export const DEFAULT_OPTION = {
  id: '',
  text: '',
  valid: false,
}
